import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showUtilModal, showSideBar, hideSideBar } from '../../redux/actions/miscActions'
import { checkUserAuthStatus } from '../../redux/actions/userActions'
import { Badge } from 'antd';

export class NavIcons extends Component {

  handleClick=()=>{
    const { isAuthenticated } = this.props.user
    this.props.hideSideBar()
    if(isAuthenticated){
      this.props.history.push('/user')
    } else {
      this.props.showUtilModal('login')
    }
  }

  
  showSidebar=()=>{
    this.props.showSideBar('cart')
  }
  
  showOrders=()=>{
    this.props.showSideBar('orders')
  }

  render() {
    const { user, isAuthenticated } = this.props.user
    const { profile } = this.props.profile
    const { cart } = this.props.cart
    
    const displayText = isAuthenticated && profile.name ?  profile.name : isAuthenticated && user.displayName ? user.displayName : user.email 
    
    let cartArray = []
    for(const property in cart){
      if(property !== 'owner' && property !== 'store'){
        cartArray.push(cart[property])
      }
    }

    const cartItems = cartArray.map((x) => {
      return x;
    });
    return (
      <div className="quick-nav-button">
      <div onClick={this.handleClick} className="user-icon">
        <img src={require('../../assets/icons/user-icon.svg')} alt=""/>
        <div className="text">
        {isAuthenticated ? displayText : 'login/register'}
        </div>
      </div>
      <div onClick={this.showSidebar}>
        <Badge
          count={cartItems.length}
          dot={true}
          offset={[0, 5]}
        >
        <img src={require('../../assets/icons/shopbag-icon.svg')} alt=""/>
        </Badge>
        <span className="nav-icon-label">Winkelmand</span>
      </div>
      <div onClick={this.showOrders}>
        <img src={require('../../assets/icons/001-bell.svg')} alt=""/>
        <span className="nav-icon-label">Mijn bestellingen</span>
      </div>
    </div>
    )
  }
}

const mapStateToProps =(state)=> ({
  user: state.user,
  cart: state.cart,
  profile: state.profile
})

export default connect(mapStateToProps, { showUtilModal, checkUserAuthStatus, showSideBar, hideSideBar })(withRouter(NavIcons))
